import script from "./SharedDeleteConfirmDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./SharedDeleteConfirmDialog.vue?vue&type=script&setup=true&lang=js"

import "./SharedDeleteConfirmDialog.vue?vue&type=style&index=0&id=6fb6f68e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6fb6f68e"]])

export default __exports__